export enum FileExplorerParams {
  nodeId = 'nodeId',
  derivationType = 'derivationType',
}

export enum FileExplorerPaths {
  explorer = 'explorer',
  agents = 'agents',
  edit = 'edit',
  errors = 'errors',
}
